import Flex from 'typescript-styled-flex'
import styled from '../../../../theme'

const Wrapper = styled(Flex.withComponent('header') as any)`
  width: 100%;
  align-items: center;
`

export default Wrapper
